export default __webpack_public_path__ + "static/media/summerchallenge12.b322fb66.jpg";